import React, { Component } from 'react';

import Header from '../components/Header/Header';
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';
import Project from '../components/Project/ProjectSingle';
import Cta from '../components/Cta/Cta';
import Footer from '../components/Footer/Footer';
import ModalSearch from '../components/Modal/ModalSearch';
import ModalMenu from '../components/Modal/ModalMenu';

class ProjectSingle extends Component {
    render() {
        return (
            <div className="main">
                <Header />
                <Breadcrumb title="TP" desc="" subpage="Project" page="Project Single" />
                <Project />
                {/* <Cta /> */}
                {/* <Footer /> */}
                <ModalSearch />
                <ModalMenu />
            </div>
        );
    }
}

export default ProjectSingle;